<template>
    <div class="c-product-variation-line c-product-line" :class="{'pim-disabled': product.IsPIMDisabled}"
        :id="'variant_' + product.Id"
        :title="[product.IsPIMDisabled ? $t('product.thumb.pim_disabled', {color: product.ColorId + ' ' + product.Color}) : '']">
        <v-product-delete @change="removeProduct" title="product.variation_thumb.delete"></v-product-delete>

        <div class="grid">
            <div class="c-product-color">
                <img v-if="variationImage" :src="variationImage" alt="" class="c-product-variation-image">
                <div v-else class="c-product-color-element" :style="`background-color: ${product.HexCode}`"></div>
                <p class="c-product-color-info">
                    <strong class="u-semi-bold">Kleur: {{ product.ColorId }} {{ product.Color }}</strong> <br>
                </p>
            </div>

            <div>
                <div class="c-form-item c-form-item--horizontal c-form-item--tiny">
                    <div class="c-label u-semi-bold">Leveringen:</div>
                    <toggle v-if="product.DeliveryDates"
                            :custom-class="{'border-error': !selectedDeliveryDates.length, 'u-pos-relative': true}"
                            custom-button-class="c-button--reset u-padding-left-tiny u-padding-right-tiny c-button--small">
                        <slot slot="toggle-button">
                            <label>
                                <span>Datums</span>
                                <span v-if="selectedDeliveryDates.length">({{ selectedDeliveryDates.length }})</span>
                            </label>
                        </slot>

                        <div v-if="!product.DeliveryDates.length" class="u-font-extra-small u-color-error-base">
                            Geen leverdata beschikbaar...
                        </div>

                        <v-filter-checkbox-element
                                v-for="item in DeliveryDates" :name="item.DeliveryDate"
                                :key="item.DeliveryDate" :value="item" @item-selected="updateProduct">
                            {{ item.DeliveryDate | moment('DD-MM-YYYY') }}
                        </v-filter-checkbox-element>

                    </toggle>
                </div>
                <div v-show="!selectedDeliveryDates.length" class="u-color-error-base u-font-extra-small">
                    Geen leverdatum(s) geselecteerd!
                </div>
                <div>
                    <v-switch v-model="product.StockSaleAllowed"
                              :name="`stock_allowed_${_uid.toString()}`"
                              @input="updateProduct">
                        <slot slot="label"><strong class="u-semi-bold">{{ $t('preorder_fiche.allow_stock_sale') }}:</strong></slot>
                    </v-switch>
                </div>
            </div>

            <div>
                <table class="c-product-info">
                    <tr>
                        <td colspan="2">
                            <v-input v-model.number="product.MaximumDiscount"
                                     input-size="tiny"
                                     :max=100 :min=0
                                     type="number"
                                     width="50px"
                                     :name="`${_uid}_variation_max_discount`"
                                     @change="updateProduct">
                                <slot slot="label"><strong class="u-semi-bold">Max korting:</strong></slot>
                            </v-input>
                        </td>
                    </tr>
                    <tr>
                        <td><label class="u-semi-bold">{{ $t('product.thumb.preOrder_campagneModel') }}:</label></td>
                        <td>
                            <v-switch v-model="product.IsCampaignModel"
                                      :name="`campaign_${_uid.toString()}`"
                                      @input="updateProduct">
                            </v-switch>
                        </td>
                    </tr>
                </table>
            </div>

            <div>
                <table class="c-product-info">
                    <tr>
                        <td><strong class="u-semi-bold">Aankoopprijs:</strong></td>
                        <td>{{ product.RetailFromPrice | currency(customerCurrencySymbol) }}</td>
                    </tr>
                    <tr>
                        <td><strong class="u-semi-bold">Adviesverkoopprijs:</strong></td>
                        <td>{{ product.OriginalFromPrice | currency(customerCurrencySymbol) }}</td>
                    </tr>
                </table>
            </div>
        </div>
        <div class="c-product-select-sizes">
            <template v-if="isSizePants">
                <v-product-pants-sizes :is-admin="true" :items="product.Variants" :waist-sizes="product.VariantsDim1" :length-sizes="product.VariantsDim2"></v-product-pants-sizes>
            </template>
            <template v-else>
                <v-product-size-toggle v-for="item in productSizes" :key="item.Id" :item.sync="item"></v-product-size-toggle>
            </template>
        </div>
    </div>
</template>

<script>
    import orderBy from 'lodash/orderBy'
    import debounce from 'lodash/debounce'
    import Toggle from '@/components/Toggle'
    import VSelect from '@/components/form/Select'
    import VInput from '@/components/form/Input'
    import VSwitch from '@/components/form/Switch'
    import VFilterCheckboxElement from '@/components/form/filters/FilterCheckboxElement'
    import VProductSizeInput from '@/components/product/widgets/productSizeInput'
    import VProductSizeToggle from '@/components/product/widgets/productSizeToggle'
    import VProductDelete from '@/components/product/widgets/productDelete'
    import VProductPantsSizes from '@/components/product/widgets/productPantsSizes'

    export default {
        props: {
            product: Object,
            parentId: String,
            groupIndex: Number,
            discountValue: Number
        },
        components: {
            Toggle,
            VSelect,
            VInput,
            VSwitch,
            VFilterCheckboxElement,
            VProductSizeInput,
            VProductSizeToggle,
            VProductDelete,
            VProductPantsSizes
        },
        data() {
            return {
                productSizes: this.product.Variants[0],
                isSizePants: this.product.SizeChartId === 2
            }
        },
        computed: {
            variationImage() {
                let output = null;
                if (this.product.Images.length) {
                    output = this.product.Images[0].replace('[WIDTH]', 60).replace('[HEIGHT]', 60);
                }
                return output;
            },
            DeliveryDates() {
                return orderBy(this.product.DeliveryDates, 'DeliveryDate')
            },
            selectedDeliveryDates() {
                let output = [];
                this.product.DeliveryDates.map(item => {
                    if (item.IsSelected) {
                        output.push(item);
                    }
                });
                return output;
            },
            customerCurrencySymbol() { 
                return this.$store.getters.userInfo.customerCurrencySymbol;
            }
        },
        watch: {
            discountValue() {
                this.product.MaximumDiscount = this.discountValue
            }
        },
        methods: {
            removeProduct() {
                this.$store.dispatch('deleteProductFromSheet', {
                    preOrderSheetId: this.parentId,
                    productId: this.product.Id,
                    groupIndex: this.groupIndex
                }).then(() => {
                    //Use parent because used in slot of ProductLineLayout
                    this.$parent.$emit('remove');
                });
            },
            updateProduct: debounce(function() {
                this.$store.dispatch('updateProductInSheet', {
                    preOrderSheetId: this.parentId,
                    productId: this.product.Id,
                    body: {
                        Id: this.product.Id,
                        MaximumDiscount: this.product.MaximumDiscount,
                        DeliveryDates: this.selectedDeliveryDates,
                        IsCampaignModel: this.product.IsCampaignModel,
                        StockSaleAllowed: this.product.StockSaleAllowed
                    }
                });
                }, 500)
            }
        }
    
</script>

<style lang="scss" scoped>

    @import "~@/assets/scss/private";

    .border-error {
        border: 1px solid $color-error;
        padding: 2px;
    }

    .pim-disabled {
        border: 4px solid $color-error;
        padding: 4px;
    }

</style>


// WEBPACK FOOTER //
// src/components/product/admin/ProductVariationLine.vue